export default __webpack_public_path__ + "static/media/bg-masthead-1.272295ac.jpg";